
export const SET_LANG = ( state, data ) => {
    state.lang = data;
    localStorage.setItem("locale", data);
}